import { IUser } from '../interfaces';

export const isReferralPatient = (user: IUser) =>
  user.signupType === 'referralPrimaryCare' ||
  user.signupType === 'referralSpecialistCare';

export const isAwaitingBooking = (user: IUser) =>
  user.onboardingCompleted && !user.appointmentCreated;

export const isReadyToBook = (user: IUser) =>
  isAwaitingBooking(user) && (user.formSubmitted || isReferralPatient(user));

export const isRegisteredAwaitingForm = (user: IUser) =>
  isAwaitingBooking(user) && !user.formSubmitted;
